export default "__VITE_ASSET__CmFXGNNa__"